<template>

    <dashboard-plugin
        name="Verdeling verschillende typen oproepen"
        instruction="De verdeling van de verschillende typen oproepen, zowel absoluut als relatief."
        :loading="loading"
        :loadedFirstTime="loadedFirstTime"
        :hasData="hasData"
    >

        <div class="flex flex-wrap mb-6">
            <p class="w-3/4 text-sm text-gray-600"> Totaal aantal oproepen: </p>
            <p class="w-1/4 text-sm font-bold"> {{ totalTypeCounts }} </p>
        </div>

        <Pie v-if="notificationTypeCountChart" :data="notificationTypeCountChart"
            :key="JSON.stringify(notificationTypeCountChart)"
        />

    </dashboard-plugin>

</template>

<script>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie } from 'vue-chartjs'

ChartJS.register(ArcElement, Tooltip, Legend)

import Api from "../api";
import DashboardPlugin from "./common/DashboardPlugin";
import loader from "./mixins/loader";

export default {

    name: 'notifications-type-count-pie-chart',

    mixins: [loader],

    components: {
        Pie,
        DashboardPlugin
    },

    props: {
        subEventNotifications: Array,
    },

    data: function ()
    {
        return {
            notificationTypeCountChart: null,
            totalTypeCounts: null,

            options: {
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },

    methods: {
        updateHandler()
        {
            this.updateChart();
        },

        async updateChart()
        {
            this.incrementLoading()

            // Reset count.
            this.totalTypeCounts = null;

            // Get the boilerplate for the chart. This needs to be a copy to trigger reactivity
            let boilerplate = _.cloneDeep(this.chartBoilerplate);

            //
            await this.manageSubEventNotifications(boilerplate);

            // Update the chart
            this.notificationTypeCountChart = boilerplate

            this.decrementLoading()
        },

        async manageSubEventNotifications(boilerplate)
        {
            // Load the count per event notification type.
            let notificationTypeCounts = await Api.getNotificationTypeCount();

            // console.info({ notificationTypeCounts });
            // console.info({ keyedSubTypeMapping: this.keyedSubTypeMapping });

            // Loop types.
            for (const [type, count] of Object.entries(notificationTypeCounts)) {

                // Get settings. Fallback to existing type (emergency, care, fire).
                let subTypeSettings = this.keyedSubTypeMapping[type] ?? null;
                let typeSettings = this.type2settings[subTypeSettings?.type || type];

                // Increase count.
                this.totalTypeCounts += count;

                // Add label and count.
                boilerplate.labels.push(subTypeSettings?.label ?? typeSettings.label);
                boilerplate['datasets'][0]['data'].push(count);

                // Set style.
                boilerplate['datasets'][0].backgroundColor.push(subTypeSettings ? 'rgba(' + subTypeSettings.color + ', 0.85)' : typeSettings.backgroundColor);
                boilerplate['datasets'][0].borderColor.push(subTypeSettings ? 'rgba(' + subTypeSettings.color + ', 1)' : typeSettings.backgroundColor);
            }
        }
    },

    computed: {

        keyedSubTypeMapping()
        {
            let result = {};
            let subEventNotifications = this.subEventNotifications || [];

            // Flatten and key.
            for(let item of Object.values(subEventNotifications))
            {
                for(let subItem of Object.values(item.mapping))
                    result[subItem?.id || (typeof subItem.match?.search == 'string' ? subItem.match.search : null) || subItem.match] = {
                        ...subItem,

                        // Add type, so we can use it as fallback.
                        type: item.type,
                    };
            }

            //
            return result;
        },

        type2settings()
        {
            return {
                fire: {
                    label: 'Brand',
                    borderColor: 'rgba(255,0,0,1)',
                    backgroundColor: 'rgba(255, 0, 0, 0.85)',
                },
                emergency: {
                    label: 'Noodgeval',
                    borderColor: 'rgba(54, 162, 235, 1)',
                    backgroundColor: 'rgba(54, 162, 235, 0.85)',
                },
                care: {
                    label: 'Mobiele zorgmelding',
                    borderColor: 'rgba(255, 206, 86, 1)',
                    backgroundColor: 'rgba(255, 206, 86, 0.85)',
                },
            };
        },

        chartBoilerplate()
        {
            return {
                labels: [],
                datasets: [{
                    data: [],

                    borderWidth: 1,
                    borderColor: [],
                    backgroundColor: [],
                }]
            }
        },

        hasData()
        {
            return this.piechartHasData(this.notificationTypeCountChart);
        }
    },

}

</script>

<style lang="scss" scoped>

</style>
